var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState, } from 'react';
import { usePopper } from 'react-popper';
import styled from 'styled-components';
import { Menu, MenuItem, propStyling, tombac, } from 'tombac';
import { UserIcon } from 'tombac-icons';
import useOutsideClick from '../../useOutsideClick';
import { useMeQuery } from '../authApi/authApiHooks';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  all: initial;\n  align-items: center;\n  cursor: ", ";\n  display: flex;\n  padding: ", ";\n  ", "\n"], ["\n  all: initial;\n  align-items: center;\n  cursor: ", ";\n  display: flex;\n  padding: ", ";\n  ", "\n"])), function (_a) {
    var menuItems = _a.menuItems;
    return (menuItems ? 'pointer' : undefined);
}, tombac.space(1, 3), propStyling);
var DropIcon = styled.span.attrs(function () { return ({ children: '▾' }); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), tombac.text());
var Email = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n\n  ", "\n"], ["\n  display: block;\n\n  ", "\n"])), tombac.text({
    color: tombac.color('neutral', 600),
    fontSize: 12,
    fontWeight: 500,
}));
var LoggedIn = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-right: ", ";\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  margin-right: ", ";\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), tombac.space(1), function (_a) {
    var breakpoint = _a.breakpoint;
    return tombac.unit(breakpoint);
});
var LoggedInLabel = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: block;\n  ", "\n"], ["\n  display: block;\n  ", "\n"])), tombac.altText({ fontSize: 12, fontWeight: 'bold' }));
var LoggedInMenuItem = styled(MenuItem)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border-bottom: ", " solid ", ";\n  display: none;\n  margin-bottom: ", ";\n  min-width: ", ";\n  padding: ", ";\n\n  @media (max-width: ", ") {\n    display: block;\n  }\n"], ["\n  border-bottom: ", " solid ", ";\n  display: none;\n  margin-bottom: ", ";\n  min-width: ", ";\n  padding: ", ";\n\n  @media (max-width: ", ") {\n    display: block;\n  }\n"])), tombac.unit(1), tombac.color('neutral', 300), tombac.space(1), tombac.space(18), tombac.space(1, 2, 2), function (_a) {
    var breakpoint = _a.breakpoint;
    return tombac.unit(breakpoint);
});
var UserImage = styled(UserIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 50%;\n  color: ", ";\n  margin-right: ", ";\n  padding: ", ";\n\n  @media (max-width: ", ") {\n    margin-right: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border-radius: 50%;\n  color: ", ";\n  margin-right: ", ";\n  padding: ", ";\n\n  @media (max-width: ", ") {\n    margin-right: ", ";\n  }\n"])), tombac.color('neutral', 400), tombac.color('neutral', 600), tombac.space(1.5), tombac.unit(2), function (_a) {
    var breakpoint = _a.breakpoint;
    return tombac.unit(breakpoint);
}, tombac.space(1));
export var LegolandNavbarMe = function (_a) {
    var _b;
    var _c = _a.breakpoint, breakpoint = _c === void 0 ? 1024 : _c, menuItems = _a.menuItems, rest = __rest(_a, ["breakpoint", "menuItems"]);
    var meQuery = useMeQuery();
    var _d = __read(useState(null), 2), referenceElement = _d[0], setReferenceElement = _d[1];
    var _e = __read(useState(null), 2), popperElement = _e[0], setPopperElement = _e[1];
    var _f = usePopper(referenceElement, popperElement, {
        placement: 'bottom-end',
    }), styles = _f.styles, attributes = _f.attributes;
    var _g = __read(useState(false), 2), isOpen = _g[0], setIsOpen = _g[1];
    var close = useCallback(function () {
        setIsOpen(false);
    }, [setIsOpen]);
    useOutsideClick(referenceElement, close);
    var loggedInLabel = React.createElement(LoggedInLabel, null, "Logged in as");
    if (!meQuery.isSuccess || !((_b = meQuery.data) === null || _b === void 0 ? void 0 : _b.me)) {
        return null;
    }
    var me = meQuery.data.me;
    return (React.createElement(Container, __assign({ className: "LegolandNavbarMe", menuItems: menuItems, onClick: function () { return setIsOpen(!isOpen); }, ref: setReferenceElement }, rest),
        React.createElement(UserImage, { breakpoint: breakpoint }),
        React.createElement(LoggedIn, { breakpoint: breakpoint },
            loggedInLabel,
            ' ',
            React.createElement(Email, { className: "LegolandNavbarMe__email" }, me.email)),
        ' ',
        menuItems && React.createElement(DropIcon, null),
        menuItems && isOpen && (React.createElement(Menu, __assign({ "$minWidth": "15sp", ref: setPopperElement, style: styles.popper }, attributes.popper),
            React.createElement(LoggedInMenuItem, { breakpoint: breakpoint },
                loggedInLabel,
                " ",
                React.createElement(Email, null, me.email)),
            menuItems))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=LegolandNavbarMe.js.map